export default "__VITE_ASSET__BkMaGp2x__"